import { render, staticRenderFns } from "./locks.vue?vue&type=template&id=162d4dd4&"
import script from "./locks.vue?vue&type=script&lang=js&"
export * from "./locks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports